var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="product_empty"> <div id="product_submenu"> <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100842'] ))==null?'':__t)+
'</li> <li class="active">'+
((__t=( resources['X100844'] ))==null?'':__t)+
'</li> <li class="active">'+
((__t=( model.Name ))==null?'':__t)+
'</li> </ol> </div> </div> </section> </div> <section class="content-block default-bg"> <div class="container"> <div id="product-details" class="row"> <div class="col-sm-8 col-md-8 space-b-xs"> <div class="clearfix"> <ul class="additional-images"> <li><a href="#" id="product_image01"><img src="'+
((__t=( model.Image01 ))==null?'':__t)+
'" alt=""></a></li> <li><a href="#" id="product_image02"><img src="'+
((__t=( model.Image02 ))==null?'':__t)+
'" alt=""></a></li> <li><a href="#" id="product_image03"><img src="'+
((__t=( model.Image03 ))==null?'':__t)+
'" alt=""></a></li> <li><a href="#" id="product_image04"><img src="'+
((__t=( model.Image04 ))==null?'':__t)+
'" alt=""></a></li> </ul> <div class="main-image"> <a href="#"><img id="product_imageMain" src="'+
((__t=( model.Image01 ))==null?'':__t)+
'" alt=""></a> </div> </div> </div> <div class="col-sm-4 col-md-4"> <div class="product-info"> <h5 class="title widget-title">'+
((__t=( model.Name ))==null?'':__t)+
'</h5> <div class="price-box clearfix"> <h5 class="price">'+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.ShowPrice ))==null?'':__t)+
'</h5> <span>'+
((__t=( resources['X100850'] ))==null?'':__t)+
' '+
((__t=( model.Currency ))==null?'':__t)+
' '+
((__t=( model.Price ))==null?'':__t)+
'</span> </div> <div class="attributes-box"> <strong>'+
((__t=( model.Description01 ))==null?'':__t)+
'</strong> </div> <div class="buy-box"> <a class="btn btn-primary" id="product_btnAddCart"><i class="fa fa-download"></i>'+
((__t=( resources['X100848'] ))==null?'':__t)+
'</a> <span class="hidden-sm">'+
((__t=( resources['X100849'] ))==null?'':__t)+
'</span> <input value="1" id="product_inputQty"> </div> </div> </div> </div> </div> </section> </div>';
}
return __p;
};
